<template>
  <div class="wt2-sg wt2-overlay-asset-picker">
    <div class="wt2-text-n2">
      {{ 'overlayAssets.main.sideBar.title' | culture }}
    </div>
    <div class="-gallery">
      <div
        v-for="(overlay, i) in overlayTracks"
        :key="getKey(overlay, i)"
        class="-background"
      >
        <overlay-thumbnail
          :overlay="overlay"
          :main="mainTrack"
          :aspect-ratio="aspectRatio"
          @click.native="showAssetLayoutEditor(overlay)"
        />
        <div class="-actions">
          <div class="-action -edit" @click="showAssetLayoutEditor(overlay)">
            <span class="wticon wticon-edit-04" title="Edit" />
          </div>
          <div class="-action -remove" @click="deleteOverlay(overlay)">
            <span class="wticon wticon-close_x" title="Delete" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import OverlayThumbnail from 'components/thumbnail/OverlayThumbnail.vue';
import PictureInPictureAdapter from 'c/PictureInPictureAdapter';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: {
    OverlayThumbnail,
  },

  methods: {
    ...mapActions('assetEditor', [
      'generateRTPByWorkModel',
      'openOverlayAssetPage',
    ]),

    getKey({ id, sceneLayout, agd, sceneAgd }, i) {
      return (
        id +
        JSON.stringify(sceneLayout) +
        JSON.stringify(agd) +
        JSON.stringify(sceneAgd) +
        i +
        this.key
      );
    },

    showAssetLayoutEditor(track) {
      this.openOverlayAssetPage({ guid: track.guid, standalone: false });
    },

    deleteOverlay(overlay) {
      this.pipa.delete(overlay.guid);
      this.generateRTPByWorkModel();
    },
  },

  data() {
    return {
      key: 0,
    };
  },

  watch: {
    agdToWatch() {
      this.key++;
    },
  },

  mounted() {
    this.pipa = new PictureInPictureAdapter({ scene: this.mainTrack });
  },

  computed: {
    ...mapGetters('assetEditor', ['currentPage', 'AGD', 'themeInfo']),
    ...mapState('assetEditor', {
      mainTrack: 'workModel',
    }),

    overlayTracks() {
      return this.mainTrack.overlayTracks;
    },

    agdToWatch() {
      return (
        this.AGD &&
        this.AGD.scale &&
        this.AGD.offset &&
        this.AGD.offset.left &&
        this.AGD.offset.top
      );
    },

    aspectRatio() {
      return app.ASPECT_RATIOS[app.currentAspectRatio].ratio;
    },
  },
};
</script>
